import { useField } from 'formik';
import { Checkbox } from '@/components/checkbox';
import { cn } from '@/lib/utils';
import styles from './FormCheckbox.module.css';

interface FormCheckboxProps {
  name: string;
  label: string;
  className?: string;
  disabled?: boolean;
}

export const FormCheckbox = ({
  name,
  label,
  className,
  disabled = false,
}: FormCheckboxProps) => {
  const [field, meta, helpers] = useField(name);

  const isChecked = Boolean(field.value);
  const isError = meta.touched && !!meta.error;

  return (
    <div className={className}>
      {/* Disabled reads as disabled, not as a box that ignores the click. */}
      <label
        className={cn(
          'flex items-center gap-2.5 cursor-pointer',
          disabled && styles.labelDisabled
        )}
      >
        <Checkbox
          id={name}
          checked={isChecked}
          onCheckedChange={(val) => helpers.setValue(Boolean(val))}
          disabled={disabled}
          aria-invalid={isError}
        />
        <span className="text-sm font-medium text-brand-primary">{label}</span>
      </label>
      {isError && (
        <span className="block text-xs mt-1 text-destructive">
          {meta.error}
        </span>
      )}
    </div>
  );
};
